import { mapState } from "vuex";

export default {
  methods: {
    isOne10PointsToCardEnabled() {
      return this.featureFlags["feature-one10-points-to-card"];
    },
    isTaxInfoEnabled() {
      return !!this.featureFlags["feature-tax-info"];
    },
    isPerformxLogoEnabled() {
      return !!this.featureFlags["feature-performx-logo"];
    },
    isPspsLookupEnabled() {
      return !!this.featureFlags["feature-psps-lookup"];
    },
    // On renders cards from the card product branding GET /cards returns; off keeps the per-client cards.
    isMarqetaCardProductsEnabled() {
      return !!this.featureFlags["feature-marqeta-card-products"];
    },
    isSSOSetupTicketsEnabled() {
      return !!this.featureFlags["feature-sso-setup-tickets"];
    },
  },
  computed: {
    ...mapState(["featureFlags"]),
  },
};
